import styled from 'styled-components';
import { DESKTOP_MIN_BREAK } from '#/shared/constants';
import BaseVehicleIcon from '#/shared/components/VehicleIcon';
import BaseArrowLeftIcon from '#/shared/components/GeneratedIcons/generic/ArrowLeft';

export const TripModeSummary = styled.div`
  max-width: ${DESKTOP_MIN_BREAK};
  color: ${props => props.theme.secondaryFontColor};
  background-color: ${props => props.theme.activeColor};
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
`;

export const TripModeInfoRow = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  flex-flow: column;
  width: 100%;
  font-size: 0.9em;
  padding: 1em 0 0.5em;
`;

export const TripModeLegIconRow = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  width: 100%;
  padding: 0px 0px 20px;
`;

export const TimeSpan = styled.span`
  color: ${props => props.theme.secondaryFontColor};
  flex: 0 0 auto;
  font-weight: bolder;
  font-size: 1.1em;
`;

export const TripInfoSpan = styled.span`
  flex: 0 0 auto;
  margin-left: 4px;
  font-size: 1.2em;
`;

export const TripModeSummaryRouteIconColumn = styled.div`
  position: relative;
  flex: 0 1 70px;
  min-height: 50px;
`;

export const TripModeSummaryIconSpacerColumn = styled.div`
  position: relative;
  flex: 0 1 25px;
  min-height: 20px;
`;

export const VehicleIcon = styled(BaseVehicleIcon).attrs({
  width: '90%',
  height: '90%',
})`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const ChevronIcon = styled(BaseArrowLeftIcon).attrs({
  width: '50%',
  height: '50%',
})`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: rotate(0.5turn) translate(50%, 50%);
`;

export const RouteBadgeWrapper = styled.div`
  position: relative;
  font-size: 0.7em;
  width: 25px;
  height: 25px;
  left: 0;
  top: 5%;
`;
